enum DefaultTopTabMenuValues {
  LiveChat = 'live-chat',
  QAndA = 'q-and-a',
  ActiveUsers = 'active-users',
  Default = LiveChat,
}

export default DefaultTopTabMenuValues
